import React, { useContext } from 'react';
import { Context } from 'components/Store';
import { FormikSelect } from 'components/UiKit/FormikFields';
import { fsaRentTypes } from '../DataSets';

const RentType = () => {
  const [{ isEnableInfoTabEdit }] = useContext(Context);
  return (
    <FormikSelect
      placeholder="Select rent type"
      id="rentType"
      name="rentType"
      items={fsaRentTypes}
      label="Rent Type"
      disabled={!isEnableInfoTabEdit}
    />
  );
};

export default RentType;
